module.exports = __webpack_public_path__ + "img/wechat.f92b1ab8.jpg";